import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Settings, ShieldAlert, Lightbulb } from 'lucide-react';
export function ProblemSlide() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      y: 20,
      opacity: 0
    },
    show: {
      y: 0,
      opacity: 1
    }
  };
  const categories = [{
    title: 'Operations',
    icon: <Settings className="w-5 h-5 md:w-6 md:h-6 text-[#00d8a8]" data-id="element-123" />,
    iconBg: 'bg-[#00d8a8]/20',
    hoverBorder: 'hover:border-[#00d8a8]/30',
    description: 'Struggling with efficient rollout and maintenance. Inconsistent smart charging implementations across charger brands.',
    questions: ['How can I deploy charging stations faster and ensure installations are first-time-right?', 'How can I minimize on‑site visits by resolving issues remotely from one dashboard?']
  }, {
    title: 'Risk',
    icon: <ShieldAlert className="w-5 h-5 md:w-6 md:h-6 text-red-400" data-id="element-124" />,
    iconBg: 'bg-red-900/20',
    hoverBorder: 'hover:border-red-500/30',
    description: 'CPOs risk getting locked into specific hardware and software providers, limiting control and flexibility.',
    questions: ['How can I stay agile in a rapidly evolving industry without being locked into specific vendors or technologies?', 'How can I keep drivers and partners within my ecosystem and avoid losing customer ownership to third‑party vendors?']
  }, {
    title: 'New Propositions',
    icon: <Lightbulb className="w-5 h-5 md:w-6 md:h-6 text-[#00d8a8]" data-id="element-125" />,
    iconBg: 'bg-[#00d8a8]/20',
    hoverBorder: 'hover:border-[#00d8a8]/30',
    description: 'Difficulty bringing compelling, differentiating approaches to market. Slow to launch new revenue models.',
    questions: ['How can I evolve my business model toward service‑based revenue streams?', 'How can I differentiate my charging offering in an increasingly crowded market?']
  }];
  return <div className="h-full w-full flex flex-col items-center justify-center px-4 md:px-12 bg-[#11166b] overflow-y-auto py-16 md:py-6" data-id="element-126">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center mb-6 md:mb-8" data-id="element-127">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-3" data-id="element-128">
          CPO Challenges at Scale
        </h2>
        <p className="text-base md:text-lg text-slate-300 max-w-3xl mx-auto" data-id="element-129">
          EV drivers expect smart charging at home. To roll this out at scale,
          CPO's often encounter pain in three critical areas:
        </p>
      </motion.div>

      <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 w-full max-w-6xl pb-20 md:pb-0" data-id="element-130">
        {categories.map((category, categoryIdx) => <motion.div key={category.title} variants={item} className={`bg-[#0d1155] border border-[#1a2080] p-5 md:p-6 rounded-2xl ${category.hoverBorder} transition-colors flex flex-col`} data-id="element-131">
            <div className={`w-10 h-10 md:w-12 md:h-12 ${category.iconBg} rounded-xl flex items-center justify-center mb-3`} data-id="element-132">
              {category.icon}
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-133">
              {category.title}
            </h3>
            <p className="text-sm text-slate-400 leading-relaxed mb-4" data-id="element-134">
              {category.description}
            </p>

            <div className="mt-auto space-y-2" data-id="element-135">
              {category.questions.map((question, qIdx) => <motion.div key={qIdx} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.6 + categoryIdx * 0.2 + qIdx * 0.1
          }} className="flex items-start gap-2 p-2.5 rounded-lg bg-[#11166b]/50 border border-[#1a2080]/50" data-id="element-136">
                  <span className="text-[#00d8a8] font-bold text-xs mt-0.5 flex-shrink-0" data-id="element-137">
                    ?
                  </span>
                  <p className="text-xs text-slate-300 leading-relaxed" data-id="element-138">
                    {question}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>)}
      </motion.div>
    </div>;
}